import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M.05 10.336q0-1.934.727-3.621A9.462 9.462 0 0 1 5.77 1.71 9.1 9.1 0 0 1 9.403.984q1.934 0 3.621.727a9.4 9.4 0 0 1 2.989 2.016 9.4 9.4 0 0 1 2.015 2.988 9.1 9.1 0 0 1 .727 3.62q0 1.606-.516 3.048a9.3 9.3 0 0 1-1.406 2.613l5.73 5.766q.188.188.282.433.105.246.105.528 0 .387-.176.703-.164.316-.468.492a1.3 1.3 0 0 1-.703.188 1.4 1.4 0 0 1-.54-.106 1.4 1.4 0 0 1-.457-.293L14.84 17.93a9.7 9.7 0 0 1-2.531 1.289 9 9 0 0 1-2.907.468q-1.934 0-3.632-.726a9.5 9.5 0 0 1-2.977-2.016A9.5 9.5 0 0 1 .777 13.97a9.1 9.1 0 0 1-.726-3.633m2.005 0q0 1.524.562 2.86.574 1.324 1.582 2.331 1.02 1.008 2.344 1.582 1.335.575 2.86.575a7.1 7.1 0 0 0 2.847-.575 7.469 7.469 0 0 0 3.926-3.914q.574-1.335.574-2.86a7.1 7.1 0 0 0-.574-2.847 7.4 7.4 0 0 0-1.582-2.343 7.2 7.2 0 0 0-2.344-1.582 7.1 7.1 0 0 0-2.848-.575 7.2 7.2 0 0 0-2.859.575 7.431 7.431 0 0 0-3.926 3.926 7.2 7.2 0 0 0-.562 2.847"
    }, null, -1)
  ]))]))
}
export default { render: render }